module.exports = __webpack_public_path__ + "media/images/careers/flex-763cf9b54687affbc43d44e8608c0cf2.svg";